module.exports = __webpack_public_path__ + "static/media/24UHCHR25.e91ef003.jpg";